import React, { Component } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import { Localization } from "./Localization";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { authenticationService } from "../../services/authentication.service";
import GlobalContext from "../../GlobalContext";
import { RoleNames } from "../../enums";
import { VersionNumber } from "./versionnumber";
import moment from "moment";
import { logController } from "../../controllers/log.controller";

class Navigation extends Component {
    state = {
        version: localStorage.getItem("version"),
        informationalVersion: localStorage.getItem("informationalVersion")
    };

    componentDidMount() {
        const { menu } = this.refs;
        $(menu).metisMenu();
        var selectedLanguage = localStorage.getItem("selectedLanguage");
        if (selectedLanguage !== null) {
            this.context.changeLanguage(selectedLanguage);
        }

        let x = this;
        let timer = setInterval(() => {
            x.setState({ currentTime: x.getCurrentTime() });
        }, 1000);

        this.setState({
            version: this.getVersionNumber(localStorage.getItem("version")),
            informationalVersion: localStorage.getItem("informationalVersion")
        });
    }

    getVersionNumber(version) {
        return VersionNumber === version ? VersionNumber : `${VersionNumber} (${version})`;
    }

    getCurrentTime() {
        return moment().format("DD.MM.YYYY HH:mm:ss");
    }

    activeRoute(routeName) {
        if (routeName === "/") return this.props.location.pathname === routeName ? "active" : "";
        return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    }

    secondLevelActive(routeName) {
        return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
    }

    languages = [
        { id: "cs", text: "Česky" },
        { id: "sk", text: "Slovensky" },
        { id: "pl", text: "Polski" }
    ];

    handleChange = (event) => {
        if (event.target.value) {
            var language = event.target.value.id;
            localStorage.setItem("selectedLanguage", language);
            this.context.changeLanguage(language);
        }
    };

    itemRender = (element, item) => {
        const children = (
            <span>
                <img src={process.env.PUBLIC_URL + "/img/flags/" + item.dataItem.id + ".png"} alt={item.dataItem.text} />
                {item.dataItem.text}
            </span>
        );

        return React.cloneElement(element, element.props, children);
    };

    valueRender = (element, value) => {
        if (!value) {
            return element;
        }

        const children = (
            <span>
                <img src={process.env.PUBLIC_URL + "/img/flags/" + value.id + ".png"} alt={value.text} />
                {value.text}
            </span>
        );

        return React.cloneElement(element, { ...element.props }, children);
    };

    getDefaultLanguage() {
        var result;
        this.languages.forEach((item) => {
            if (item.id === this.context.language) {
                result = item;
            }
        });
        return result;
    }

    renderToolsLink() {
        if (authenticationService.hasCurrentUserRole(RoleNames.Administrator)) {
            return (
                <li className={this.activeRoute("/tools")}>
                    <Link to="/tools">
                        {" "}
                        <Localization messageKey={"Navigation.Nástroje"} defaultMessage={"Nástroje"} />
                    </Link>
                </li>
            );
        }
        return;
    }

    renderLog4NetLink() {
        if (authenticationService.hasCurrentUserRole(RoleNames.Administrator)) {
            return (
                <li className={this.activeRoute("/log")}>
                    <Link to="/log">
                        {" "}
                        <Localization messageKey={"Navigation.Log"} defaultMessage={"Log"} />
                    </Link>
                </li>
            );
        }
        return;
    }

    renderElmahLink() {
        if (authenticationService.hasCurrentUserRole(RoleNames.Administrator)) {
            return (
                <React.Fragment>
                    |{" "}
                    <a href="/elmah" target="_blank" rel="noopener noreferrer">
                        <Localization messageKey={"Navigation.Výpis chýb"} defaultMessage={"Výpis chýb"} />
                    </a>
                </React.Fragment>
            );
        }
        return;
    }

    logout() {
        authenticationService.logout();
        if (this && this.props && this.props.history) this.props.history.push("/login");
    }

    render() {
        return (
            <React.Fragment>
                <div className="row border-bottom white-bg">
                    <nav className="navbar navbar-static-top" role="navigation">
                        <div className="navbar-header">
                            <button
                                aria-controls="navbar"
                                aria-expanded="false"
                                data-target="#navbar"
                                data-toggle="collapse"
                                className="navbar-toggle collapsed"
                                type="button">
                                <i className="fa fa-reorder"></i>
                            </button>
                            <Link to="/" className="navbar-brand">
                                <img src={process.env.PUBLIC_URL + "/img/gate_logo_dark.png"} alt="Logo" height="40" />
                            </Link>
                        </div>
                        <div className="navbar-collapse collapse" id="navbar">
                            <ul className="nav navbar-nav">
                                <li className={this.activeRoute("/")}>
                                    <Link to="/">
                                        {" "}
                                        <Localization messageKey={"Navigation.Hlavná stránka"} defaultMessage={"Hlavná stránka"} />
                                    </Link>
                                </li>
                                {this.renderToolsLink()}
                                {this.renderLog4NetLink()}
                                <li className="dropdown">
                                    <a aria-expanded="false" role="button" href="#" className="dropdown-toggle" data-toggle="dropdown">
                                        O aplikaci <span className="caret"></span>
                                    </a>
                                    <ul role="menu" className="dropdown-menu info-o-aplikaci">
                                        <li className="version">
                                            <Localization messageKey={"Navigation.Verzia"} defaultMessage={"Verzia"} />:{" "}
                                            <span title={this.state.informationalVersion}>{this.state.version}</span> {this.renderElmahLink()}
                                        </li>
                                        <li>
                                            <strong>Copyright</strong> GATE, a.s. &copy; 2019
                                            <br />
                                            <strong>Developed by</strong>{" "}
                                            <a href="https://www.tsium.cz" target="_blank" rel="noopener noreferrer">
                                                tsium software
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                {/* <li className="dropdown">
                                    <a aria-expanded="false" role="button" href="#" className="dropdown-toggle" data-toggle="dropdown">
                                        Menu item <span className="caret"></span>
                                    </a>
                                    <ul role="menu" className="dropdown-menu">
                                        <li>
                                            <a href="">Menu item</a>
                                        </li>
                                        <li>
                                            <a href="">Menu item</a>
                                        </li>
                                        <li>
                                            <a href="">Menu item</a>
                                        </li>
                                        <li>
                                            <a href="">Menu item</a>
                                        </li>
                                    </ul>
                                </li> */}
                            </ul>
                            <ul className="nav navbar-top-links navbar-right">
                                <li className="navbar-font-small">
                                    {this.state.version}
                                    <br />
                                    {this.state.currentTime}
                                </li>
                                <li>
                                    <div className="language-dropdown">
                                        <DropDownList
                                            data={this.languages}
                                            textField="text"
                                            dataItemKey="id"
                                            value={this.getDefaultLanguage()}
                                            itemRender={this.itemRender}
                                            valueRender={this.valueRender}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                </li>
                                <li>
                                    <div className="profile-element">
                                        <i className="fa fa-user"></i> <strong className="font-bold">{authenticationService.currentUzivatelMeno}</strong>{" "}
                                        <span className="text-muted text-xs">({authenticationService.currentSkladNazov})</span>
                                    </div>
                                </li>
                                <li>
                                    <a href="#" onClick={this.logout}>
                                        {" "}
                                        <i className="fa fa-sign-out"></i> <Localization messageKey={"Navigation.Odhlásiť"} defaultMessage={"Odhlásiť"} />{" "}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>

                {/* <Footer /> */}
            </React.Fragment>
        );
    }
}
Navigation.contextType = GlobalContext;

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/common/Navigation.js